import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { DiagnosisSection } from '../components/DiagnosisSection';
import { SystemSection } from '../components/SystemSection';
import { ResultsSection } from '../components/ResultsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FinalCTA } from '../components/FinalCTA';
export function LandingPage() {
  return <main className="min-h-screen bg-carbon w-full overflow-x-hidden selection:bg-gold selection:text-carbon" data-id="element-63">
      <HeroSection data-id="element-64" />
      <DiagnosisSection data-id="element-65" />
      <SystemSection data-id="element-66" />
      <ResultsSection data-id="element-67" />
      <GuaranteeSection data-id="element-68" />
      <FinalCTA data-id="element-69" />
    </main>;
}